import parse from "html-react-parser"
import { ReactComponent as Icon } from "../../Icons/downarrow.svg";
import { useEffect, useRef, useState } from "react";

const Features = ({ data }) => {
    const [toggle, setToggle] = useState(-1)
    const refs = useRef([]);

    const handleOpen = (ind) => {
        if (ind == toggle) {
            setToggle(-1)
            return;
        }
        setToggle(ind)
    }

    useEffect(() => {
        function handleClickOutside(event) {
            const clickedInsideAny = refs.current.some(
                (ref) => ref && ref.contains(event.target)
            );

            if (!clickedInsideAny) {
            setToggle(-1)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="2xl:container mx-auto lg:px-20 pt-10 md:pt-20  md:px-14 px-6">
            <div className="flex flex-col gap-16 items-center">
                <div className="flex flex-col text-center items-center gap-4 md:w-[80%]">
                    <h2 className="md:text-48 text-primarycolor text-24 sm:text-32 font-semibold">{data.heading}</h2>
                    <p className="text-18 font-regular text-secondaryblack">{parse(data.desc)}</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 relative w-full">
                    {
                        data.list.map((item, index) => (
                            <div  ref={(el) => (refs.current[index] = el)} key={index} className="feature-hover ">
                                <div className="flex flex-col gap-4 feature-second items-start  w-full relative ">
                                    <div onClick={() => handleOpen(index)} className="flex gap-4 justify-between items-center w-full p-4 border border-journeyborder cursor-pointer hover:shadow-products  rounded-[16px]">
                                        <div className="flex gap-x-4 items-center">
                                            <img
                                                src={process.env.PUBLIC_URL + item.titleIcon}
                                                alt="icon"
                                            />
                                            <h4 className="text-18 font-semibold text-primarycolor text-left">{item.title}</h4>
                                        </div>
                                        <Icon
                                            width={"15px"}
                                            height={"15px"}
                                            className={`text-secondaryblack ${toggle == index ? "rotate-180" : ""}`}
                                        />
                                    </div>
                                    {toggle == index ? <div className="flex flex-col gap-4 absolute top-[100px] z-10 bg-white feature-list  w-full p-4 border border-journeyborder shadow-products  rounded-[16px]">
                                        {item.content.map((para, ind) => (
                                            <p key={ind} className="text-16 text-left font-regular text-primaryColor flex gap-4 ">
                                                <img
                                                    src={process.env.PUBLIC_URL + item.icon}
                                                    alt="icon"
                                                />
                                                <span>{para}</span>
                                            </p>
                                        ))}
                                    </div> : <></>}
                                </div>
                            </div>
                        ))
                    }
                </div>

            </div>
        </div>

    )
}
export default Features;